"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _reactRedux = require("react-redux");

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _immutable = _interopRequireDefault(require("immutable"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _UICloseButton = _interopRequireDefault(require("UIComponents/button/UICloseButton"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UILoadingButton = _interopRequireDefault(require("UIComponents/button/UILoadingButton"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _UISection = _interopRequireDefault(require("UIComponents/section/UISection"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _resize = _interopRequireDefault(require("FileManagerCore/utils/resize"));

var _image = require("FileManagerCore/utils/image");

var _Shutterstock = require("FileManagerLib/actions/Shutterstock");

var _UserSettings = require("FileManagerCore/actions/UserSettings");

var _ShutterstockPreviewModal = _interopRequireDefault(require("FileManagerCore/components/ShutterstockPreviewModal"));

var _ShutterstockLicenseAgreement = _interopRequireDefault(require("FileManagerCore/components/ShutterstockLicenseAgreement"));

var _Shutterstock2 = require("FileManagerCore/selectors/Shutterstock");

var _Auth = require("FileManagerCore/selectors/Auth");

var _Actions = require("FileManagerLib/actions/Actions");

var _Constants = require("FileManagerCore/Constants");

var _UserSettings2 = require("FileManagerCore/selectors/UserSettings");

var WIDTH = 380;
var ARROW_WIDTH = 16;

var ShutterstockDetail =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(ShutterstockDetail, _Component);

  function ShutterstockDetail(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ShutterstockDetail);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ShutterstockDetail).call(this, props));
    _this.state = {};
    _this.updateHeight = _this.updateHeight.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleCloseButtonClick = _this.handleCloseButtonClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleInsert = _this.handleInsert.bind((0, _assertThisInitialized2.default)(_this));
    _this.handlePreview = _this.handlePreview.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleAcquire = _this.handleAcquire.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleChangeFolder = _this.handleChangeFolder.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleClose = _this.handleClose.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleAgree = _this.handleAgree.bind((0, _assertThisInitialized2.default)(_this));
    _this.closePreview = _this.closePreview.bind((0, _assertThisInitialized2.default)(_this));
    _this.insert = _this.insert.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ShutterstockDetail, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startMutationObserver();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopMutationObserver();
    }
  }, {
    key: "closePreview",
    value: function closePreview() {
      this.setState({
        showAgreement: false,
        showPreview: false
      });
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.closePreview();
    }
  }, {
    key: "handlePreview",
    value: function handlePreview() {
      this.setState({
        showPreview: true
      });
    }
  }, {
    key: "handleChangeFolder",
    value: function handleChangeFolder(folder) {
      var _this$props = this.props,
          user = _this$props.user,
          userSettings = _this$props.userSettings,
          onSaveUserSettings = _this$props.onSaveUserSettings;
      onSaveUserSettings(user.user_id, userSettings.set('shutterstockFolderId', folder.get('id')));
    }
  }, {
    key: "handleAgree",
    value: function handleAgree() {
      var _this$props2 = this.props,
          onSaveUserSettings = _this$props2.onSaveUserSettings,
          user = _this$props2.user,
          userSettings = _this$props2.userSettings;
      this.closePreview();
      onSaveUserSettings(user.user_id, userSettings.set('signedShutterstock', true));
      this.insert();
    }
  }, {
    key: "handleAcquire",
    value: function handleAcquire() {
      this.closePreview();
      this.handleInsert();
    }
  }, {
    key: "getDimensions",
    value: function getDimensions() {
      var tile = this.props.tile;
      var image = tile.get('image');

      if (!image.get('width') || !image.get('height')) {
        return null;
      }

      return image.get('width') + " x " + image.get('height') + " px";
    }
  }, {
    key: "getImageSrc",
    value: function getImageSrc(image) {
      var url = image.get('largePreviewUrl');
      return (0, _resize.default)(url, {
        width: WIDTH * 2
      });
    }
  }, {
    key: "startMutationObserver",
    value: function startMutationObserver() {
      var wrapperNode = (0, _reactDom.findDOMNode)(this.wrapper);
      var _window = window,
          MutationObserver = _window.MutationObserver;

      if (!MutationObserver) {
        return;
      }

      this.observer = new MutationObserver(this.updateHeight);
      this.observer.observe(wrapperNode, {
        attributes: true,
        childList: true,
        subtree: true
      });
    }
  }, {
    key: "stopMutationObserver",
    value: function stopMutationObserver() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }
  }, {
    key: "updateHeight",
    value: function updateHeight() {
      var _this$props3 = this.props,
          tile = _this$props3.tile,
          onUpdateHeight = _this$props3.onUpdateHeight;
      var image = tile.get('image');
      var wrapperNode = (0, _reactDom.findDOMNode)(this.wrapper);
      var height = wrapperNode.clientHeight;

      if (tile.get('height') !== height) {
        onUpdateHeight(image, height);
      }
    }
  }, {
    key: "handleCloseButtonClick",
    value: function handleCloseButtonClick() {
      var onClose = this.props.onClose;
      onClose({
        target: 'close-button'
      });
    }
  }, {
    key: "handleInsert",
    value: function handleInsert() {
      var userSettings = this.props.userSettings;

      if (!userSettings.get('signedShutterstock')) {
        this.setState({
          showAgreement: true
        });
      } else {
        this.insert();
      }
    }
  }, {
    key: "insert",
    value: function insert() {
      var _this2 = this;

      var _this$props4 = this.props,
          tile = _this$props4.tile,
          onAcquire = _this$props4.onAcquire,
          onTrackInteraction = _this$props4.onTrackInteraction,
          onClose = _this$props4.onClose,
          onInsert = _this$props4.onInsert,
          userSettings = _this$props4.userSettings;
      var image = tile.get('image');
      var title = image.get('title');
      var shutterstockId = image.get('id');
      this.setState({
        saving: true
      });
      var folderId;

      if (userSettings.has('shutterstockFolderId')) {
        folderId = userSettings.get('shutterstockFolderId');
      }

      onTrackInteraction('Browse Shutterstock', 'clicked-save-to-files');
      onAcquire(shutterstockId, title, folderId).then(function (file) {
        _this2.setState({
          saving: false
        });

        onClose();
        onInsert(file);
      }).catch(function () {
        _this2.setState({
          saving: false,
          failed: true
        });
      });
    }
  }, {
    key: "renderArrow",
    value: function renderArrow(tile) {
      var arrowX = tile.get('arrowX');
      return _react.default.createElement("div", {
        className: "file-detail__arrow",
        style: {
          left: arrowX - ARROW_WIDTH * 0.5
        }
      });
    }
  }, {
    key: "renderTitle",
    value: function renderTitle(image) {
      return _react.default.createElement("p", {
        className: "m-right-4"
      }, image.get('title'));
    }
  }, {
    key: "renderImage",
    value: function renderImage(image) {
      var dimensions = (0, _image.scaleToFit)(image, WIDTH);
      return _react.default.createElement("div", {
        className: "file-detail__image-wrapper m-bottom-4"
      }, _react.default.createElement(_UIImage.default, (0, _extends2.default)({
        className: "file-detail__image",
        src: this.getImageSrc(image),
        responsive: false,
        draggable: false
      }, dimensions)));
    }
  }, {
    key: "renderInsertButton",
    value: function renderInsertButton() {
      return _react.default.createElement(_UILoadingButton.default, {
        use: "primary",
        preventClicksOnLoading: true,
        loading: this.state.saving || false,
        failed: this.state.failed || false,
        onClick: this.handleInsert
      }, _I18n.default.text('FileManagerLib.actions.insert'));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props5 = this.props,
          tile = _this$props5.tile,
          shutterstockFolder = _this$props5.shutterstockFolder,
          userSettings = _this$props5.userSettings,
          onTrackInteraction = _this$props5.onTrackInteraction;
      var _this$state = this.state,
          showPreview = _this$state.showPreview,
          showAgreement = _this$state.showAgreement;
      var image = tile.get('image');
      var dimensions = this.getDimensions();
      return _react.default.createElement("div", {
        ref: function ref(c) {
          _this3.wrapper = c;
        },
        className: "file-detail"
      }, this.renderArrow(tile), _react.default.createElement("div", {
        className: "file-detail__wrapper"
      }, _react.default.createElement(_UICloseButton.default, {
        className: "file-detail__close-button",
        size: "medium",
        onClick: this.handleCloseButtonClick
      }), this.renderTitle(image), this.renderImage(image), _react.default.createElement(_UIList.default, {
        className: "file-detail__meta m-bottom-4"
      }, dimensions && _react.default.createElement(_Small.default, {
        use: "help"
      }, _I18n.default.text('FileManagerLib.fileDetail.dimensions', {
        dimensions: dimensions
      }))), _react.default.createElement("div", {
        className: "flex-wrap justify-start"
      }, this.renderInsertButton(), _react.default.createElement(_UIButton.default, {
        use: "transparent",
        onClick: this.handlePreview,
        className: "m-left-6"
      }, _I18n.default.text('FileManagerLib.panels.tabs.shutterstock.actions.previewLink'))), _react.default.createElement("div", null, showAgreement && _react.default.createElement(_ShutterstockLicenseAgreement.default, {
        onAgree: this.handleAgree,
        onCancel: this.handleClose,
        onClose: this.handleClose
      }), showPreview && _react.default.createElement(_ShutterstockPreviewModal.default, {
        image: image,
        userSettings: userSettings,
        shutterstockFolder: shutterstockFolder,
        onChangeFolder: this.handleChangeFolder,
        onAcquire: this.handleAcquire,
        onAgree: this.handleAgree,
        onClose: this.handleClose,
        onTrackInteraction: onTrackInteraction
      })), _react.default.createElement(_UISection.default, {
        className: "m-y-3"
      }, _react.default.createElement(_Small.default, {
        use: "help"
      }, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: "FileManagerLib.panels.tabs.shutterstock.copyInformation",
        options: {
          stockFolder: shutterstockFolder ? shutterstockFolder.get('name') : _Constants.ShutterstockFolderName
        }
      })))));
    }
  }]);
  return ShutterstockDetail;
}(_react.Component);

ShutterstockDetail.propTypes = {
  tile: _react.PropTypes.instanceOf(_immutable.default.Map).isRequired,
  onClose: _react.PropTypes.func.isRequired,
  onUpdateHeight: _react.PropTypes.func.isRequired,
  onInsert: _react.PropTypes.func.isRequired,
  onAcquire: _react.PropTypes.func.isRequired,
  onSaveUserSettings: _react.PropTypes.func.isRequired,
  shutterstockFolder: _react.PropTypes.instanceOf(_immutable.default.Map),
  userSettings: _react.PropTypes.instanceOf(_immutable.default.Map).isRequired,
  onTrackInteraction: _react.PropTypes.func.isRequired,
  user: _react.PropTypes.object.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    user: (0, _Auth.getUser)(state),
    userSettings: (0, _UserSettings2.getUserSettings)(state),
    shutterstockFolder: (0, _Shutterstock2.getShutterstockFolder)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onAcquire: function onAcquire(shutterstockId, filename, folderId, onSuccess, onError) {
      return dispatch((0, _Shutterstock.acquireImage)(shutterstockId, filename, folderId, onSuccess, onError));
    },
    onSaveUserSettings: function onSaveUserSettings(userId, updatedSettings) {
      dispatch((0, _UserSettings.saveUserSettings)(userId, updatedSettings));
    },
    onTrackInteraction: function onTrackInteraction(name, action, meta) {
      dispatch((0, _Actions.trackInteraction)(name, action, meta));
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ShutterstockDetail);

exports.default = _default;
module.exports = exports.default;